import React from 'react';
import { BookOpenIcon, FileTextIcon, TrendingUpIcon, GiftIcon } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpenIcon className="w-8 h-8 text-gold" data-id="element-200" />,
    title: 'La Guía Maestra',
    description: 'Nada de relleno, solo los pasos exactos del 1 al 10 para limpiar tu historial sin confusiones.'
  }, {
    icon: <FileTextIcon className="w-8 h-8 text-gold" data-id="element-201" />,
    title: "3 Cartas de Disputa 'Blindadas'",
    description: 'Diseñadas con lenguaje legal específico para evadir los scanners de IA y forzar una revisión humana.'
  }, {
    icon: <TrendingUpIcon className="w-8 h-8 text-gold" data-id="element-202" />,
    title: 'El Método de Reconstrucción',
    description: 'Estrategias poco conocidas para subir 100 puntos rápido usando deudas que ya tienes.'
  }, {
    icon: <GiftIcon className="w-8 h-8 text-gold" data-id="element-203" />,
    title: 'BONUS: Deducibles Invisibles',
    description: 'Lista exclusiva para trabajadoras por cuenta propia para maximizar tus impuestos.'
  }];
  return <section className="py-12 md:py-20 bg-white" data-id="element-204">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-205">
        <div className="text-center mb-8 md:mb-12" data-id="element-206">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-navy mb-3" data-id="element-207">
            Todo Lo Que Recibes Hoy
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm md:text-base" data-id="element-208">
            Años de experiencia legal y financiera destilados en un sistema
            simple de seguir.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-209">
          {items.map((item, index) => <div key={index} className="flex items-start p-4 md:p-6 rounded-xl border border-gray-100 hover:border-gold/50 hover:shadow-lg transition-all duration-300 bg-cream/30" data-id="element-210">
              <div className="flex-shrink-0 mr-4 bg-navy/5 p-2.5 rounded-lg" data-id="element-211">
                {item.icon}
              </div>
              <div data-id="element-212">
                <h3 className="font-heading text-lg md:text-xl font-bold text-navy mb-1.5" data-id="element-213">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-214">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}